import { FC } from "react";
import { AddOnGroup } from "components/summary/index/Revenue/addonBreakdown";
import { WXCC_ADDON_LABELS } from "constant/wxcc-addons";

interface WxccAddOnCategoryBadgeProps {
  group: Pick<AddOnGroup, "color" | "backgroundColor"> & {
    category: AddOnGroup["category"] | typeof WXCC_ADDON_LABELS.all;
  };
  variant?: "default" | "footer";
}

const WxccAddOnCategoryBadge: FC<WxccAddOnCategoryBadgeProps> = ({
  group,
  variant = "default",
}) => (
  <span
    style={{
      backgroundColor: group.backgroundColor,
      borderRadius: 999,
      color: group.color,
      fontSize: variant === "footer" ? 11 : 12,
      lineHeight: variant === "footer" ? undefined : "18px",
      fontWeight: 700,
      padding: variant === "footer" ? "4px 8px" : "3px 7px",
    }}
  >
    {group.category}
  </span>
);

export default WxccAddOnCategoryBadge;
